<template>
  <div class="attribute-selector">
    <v-autocomplete
      ref="autocomplete"
      v-model="selectedKeys"
      :items="availableAttributeItems"
      :label="$t('attributes.filters.filterByAttributes')"
      :loading="loading"
      item-text="text"
      item-value="value"
      chips
      small-chips
      multiple
      deletable-chips
      :counter="maxSelections"
      :rules="[limitRule]"
      :item-disabled="isItemDisabled"
      @change="onChange"
    />

    <div v-if="selectionError" class="error--text text-caption mt-1">
      {{ selectionError }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttributeSelector',
  props: {
    value: {
      type: Array,
      required: true,
    },
    availableAttributes: {
      type: Array,
      default: () => [],
    },
    maxSelections: {
      type: Number,
      required: true,
    },
    maxValues: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectionError: '',
    };
  },
  computed: {
    availableAttributeItems() {
      return this.availableAttributes
        .filter(attr => attr && attr.key)
        .map(attr => ({
          text: attr.displayDescription ? attr.displayDescription : attr.key,
          value: attr.key,
          valuesCount: attr.distinctValues ? attr.distinctValues.length : 0,
        }));
    },
    selectedKeys: {
      get() {
        return this.value.map(a => (a.key ? a.key : a));
      },
      set(nextKeys) {
        const next = this.availableAttributes
          .filter(attr => nextKeys.includes(attr.key))
          .map(attr => ({ key: attr.key, displayName: attr.displayDescription }));
        this.$emit('input', next);
      },
    },
  },
  watch: {
    selectedKeys(newKeys) {
      if (Array.isArray(newKeys) && newKeys.length > this.maxSelections) {
        this.selectedKeys = newKeys.slice(0, this.maxSelections);
      }
    },
  },
  methods: {
    limitRule(values) {
      if (!values) return true;
      if (values.length > this.maxSelections) {
        this.selectionError = this.$t('reporting.config.maxAttributesError', {
          max: this.maxSelections,
        });
        return false;
      }
      // validate attribute value count when available
      const overLimit = this.availableAttributeItems.some(
        item => values.includes(item.value) && item.valuesCount > this.maxValues
      );
      if (overLimit) {
        this.selectionError = this.$t('reporting.config.maxValuesError', { max: this.maxValues });
        return false;
      }
      this.selectionError = '';
      return true;
    },
    onChange(values) {
      if (values.length > this.maxSelections) {
        this.selectedKeys = values.slice(0, this.maxSelections);
      }
    },
    isItemDisabled(item) {
      const isSelected = this.selectedKeys.includes(item.value);
      return this.selectedKeys.length >= this.maxSelections && !isSelected;
    },
    focusAndOpen() {
      // Focus on the autocomplete and open the dropdown
      this.$refs.autocomplete.$refs.input.focus();
      this.$refs.autocomplete.activateMenu();
    },
  },
};
</script>

<style scoped></style>
